export default "__VITE_ASSET__COfJ$Pz0__"